import { render, staticRenderFns } from "./CustomerSearchDropdown.vue?vue&type=template&id=1ddfb6bb"
import script from "./CustomerSearchDropdown.vue?vue&type=script&lang=js"
export * from "./CustomerSearchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports